{
  "verified": "Verificat",
  "iv_status": {
    "verified": "Verificat",
    "pending": "În așteptare",
    "attention": "Atenție"
  },
  "zoom_in": "Zoom in",
  "zoom_out": "Zoom Out",
  "rotate": "Rotiți",
  "close": "Închidere",
  "esc_to_close": "Apăsați ESC pentru a închide",
  "play": "Joc",
  "pause": "Pauză",
  "mute": "Mută",
  "unmute": "Dezactivați",
  "enter_full_screen": "Introduceți ecranul complet",
  "exit_full_screen": "Ieșire ecran complet",
  "video_not_supported": "Browserul dvs. nu acceptă eticheta video.",
  "skip_forward": "Salt înainte",
  "skip_backward": "Salt înapoi",
  "loading": "Încărcare",
  "loading_video": "Încărcare video...",
  "loading_data_description": "Vă rugăm să așteptați până vă încărcăm datele. Acest lucru nu va dura mult.",
  "no_results": "Niciun rezultat",
  "nothing_found": "Nu s-a găsit nimic",
  "save_changes": "Salvați modificările",
  "saved_exclamation": "Salvat!",
  "saving": "Economisire",
  "validating": "Validarea",
  "error": "Eroare",
  "optional": "Opțional",
  "search_property": "Căutare proprietate",
  "reset_search": "Resetați căutarea",
  "no_items_to_show": "Nu există articole de prezentat",
  "showing_range_of_total_items": "Se afișează {{range}} din {{total}} articole",
  "rows_per_page": "Rânduri pe pagină",
  "page_of_pages": "Pagina {{page}} din {{pages}}",
  "go_to_first_page": "Mergeți la prima pagină",
  "go_to_previous_page": "Mergeți la pagina anterioară",
  "go_to_next_page": "Mergeți la pagina următoare",
  "go_to_last_page": "Mergeți la ultima pagină",
  "sort_in_asc": "Sortare în ordine crescătoare",
  "sort_in_desc": "Sortare în ordine descrescătoare",
  "sort_a_z": "Sortare A → Z",
  "sort_z_a": "Sort Z → A",
  "clear_sorting": "Sortare clară",
  "reach_us_at_email": "Obțineți asistență la support@chekin.com",
  "please_wait": "Vă rugăm să așteptați",
  "feature_coming_soon": "În curând",
  "feature_coming_soon_description": "Această caracteristică este în curs de dezvoltare și va fi disponibilă în curând. Rămâneți pe recepție pentru actualizări!",
  "download_all": "Descărcați tot",
  "entry_forms": "Formulare de înscriere",
  "tutorial": "Tutorial",
  "liveness_video": "Liveness video",
  "beta": "Beta",
  "reviews": "Recenzii",
  "learn_more": "Aflați mai multe",
  "this_cannot_be_reverted": "Acest lucru nu poate fi anulat",
  "delete": "Ștergeți",
  "cancel": "Anulează",
  "you_have_made_changes": "Ați efectuat modificări",
  "would_you_like_to_save_them": "Doriți să le salvați?",
  "save": "Salvați",
  "dont_save": "Nu salvați",
  "copied_exclamation": "Copiat!",
  "search_placeholder": "Căutare...",
  "type_to_search": "Tastați pentru a căuta...",
  "loading_more": "Încărcare...",
  "no_options": "Nu există opțiuni",
  "select_option": "Selectați opțiunea",
  "clear_all": "Ștergeți toate",
  "remove_item": "Eliminați {{label}}",
  "upload_file": "Încărcați fișierul",
  "download_attachment": "Descărcați atașamentul",
  "remove_file": "Îndepărtați fișierul",
  "open_calendar": "Deschideți calendarul",
  "clear_dates": "Date clare",
  "select_dates": "Selectați datele",
  "pick_date_range": "Alegeți un interval de date",
  "from": "De la",
  "to": "La",
  "pick_month": "Alegeți o lună",
  "pick_date": "Alegeți o dată",
  "month": "Luna",
  "day": "Ziua",
  "year": "Anul",
  "done": "Efectuat",
  "wrong_period_of_dates": "Perioada selectată nu este valabilă",
  "date_range_max_days_error_one": "Intervalul nu poate depăși {{count}} zi",
  "date_range_max_days_error_other": "Intervalul nu poate depăși {{count}} zile",
  "date_range_min_days_error_one": "Intervalul trebuie să fie de cel puțin {{count}} zi",
  "date_range_min_days_error_other": "Intervalul trebuie să fie de cel puțin {{count}} zile",
  "past_dates": "Data nu poate fi anterioară {{minDate}}",
  "future_dates": "Data nu poate fi după {{maxDate}}",
  "signature_placeholder_text": "Semnați în interiorul acestei casete.<br/> Folosiți degetul.<br/> Atingeți pentru a începe.",
  "open_devices_camera": "Deschideți camera dispozitivului",
  "place_document_inside_frame": "Plasați documentul în interiorul ramei",
  "close_other_application_that_may_be_using_your_camera": "Închideți alte aplicații care pot utiliza camera dvs.",
  "if_you_use_external_camera_disconnect_and_reconnect": "Dacă utilizați o cameră externă, deconectați-o și reconectați-o",
  "close_the_browser_re_open_it": "Închideți browserul și redeschideți-l",
  "camera_errors": {
    "experiencing_camera_issues": "Aveți probleme cu camera foto?",
    "chekin_cant_use_your_camera": "Chekin nu-ți poate folosi camera",
    "please_try_a_different_browser": "Camera dvs. nu funcționează în acest browser. Vă rugăm să încercați să deschideți link-ul într-un alt browser.",
    "permissions_denied": "Permisiune refuzată",
    "camera_permissions_denied": "Camera nu se deschide? Asigurați-vă că acordați browserului permisiunea de a utiliza camera.",
    "no_camera_device_found": "Nu a fost găsit niciun dispozitiv de cameră. Vă rugăm să conectați o cameră.",
    "constraints_camera_error": "Constrângerile nu pot fi îndeplinite de dispozitivele disponibile.",
    "safari_camera_error": "Safari nu a putut satisface cerințele camerei",
    "try_chrome_or_firefox": "Vă rugăm să încercați Chrome sau Firefox"
  },
  "clear": "Clar",
  "show_less": "Arată mai puțin",
  "show_more": "Arată mai multe",
  "tap_here_to_sign": "Atingeți aici pentru a semna",
  "click_here_to_sign": "Faceți clic aici pentru a semna",
  "prefix": "Prefix",
  "prefix_required": "Prefixul este necesar",
  "reset": "Resetare",
  "show_password": "Afișați parola",
  "hide_password": "Ascundeți parola",
  "increment": "Increment",
  "decrement": "Diminuare",
  "create_option": "Creați \"{{input}}\"",
  "year_out_of_range": "Anul trebuie să fie între {{min}} și {{max}}",
  "clear_date": "Data clară",
  "select_date": "Selectați data",
  "draw_signature_here": "Semnează aici",
  "signature_hint": "Folosește mouse-ul sau degetul",
  "clear_signature": "Semnătură clară",
  "draw_signature_here_mobile": "Desenează-ți semnătura",
  "signature_hint_mobile": "Folosește degetul",
  "camera_access_needed": "Este necesar accesul la cameră",
  "camera_access_needed_text": "Permiteți accesul la cameră pentru a face fotografia. Dacă accesul este blocat, activați camera din setările browserului, apoi încercați din nou.",
  "dialog": "Dialog"
}
